import { GENERAL_STATUS } from '../../../constants/constants';
import StatusPill from '../StatusPill/StatusPill';

export const GeneralStatusPill: React.FC<{ status: number }> = ({ status }) => {
  switch (status) {
    case GENERAL_STATUS.ACTIVE:
      return <StatusPill color="primary-purple" text="Active" size="small" />;
    case GENERAL_STATUS.INACTIVE:
      return <StatusPill color="primary" text="Inactive" size="small" />;
    default:
      return <div />;
  }
};
